@if (chatBotSvc.isDisplayed$()) {
  <azavista-icon-button action="close" (click)="close()" icon="close" color="primary"></azavista-icon-button>
}
